import { UseQueryResult } from '@tanstack/react-query'
import useApi, { type ResponseError } from '@/api/base/useApi'
import { ActionPoint } from '@/types'

async function fetchActionPoints(accessToken: string | undefined, userId: string | undefined): Promise<ActionPoint[]> {
  const url = `${process.env['NEXT_PUBLIC_API_ENDPOINT']}actionpoints/`

  if (!accessToken) {
    return Promise.reject('No access token (fetchActionPoints).')
  }

  const requestHeaders: any = { Authorization: 'Bearer ' + accessToken, 'auth0-user-id': userId }
  const response = await fetch(url, {
    method: 'GET',
    headers: requestHeaders,
  })

  if (response.status !== 200) {
    const json: ResponseError = await response.json()
    console.log('[admin/fetchActionPoints] Error', response)
    return Promise.reject(json)
  }

  return response.json()
}

const useActionPointsQueryV1 = (enabled?: boolean): UseQueryResult<ActionPoint[], any> =>
  useApi(['actionpoints'], fetchActionPoints, {}, enabled)

export default useActionPointsQueryV1
